import { render, staticRenderFns } from "./PlatFormMain.vue?vue&type=template&id=8c988bfa&"
import script from "./PlatFormMain.vue?vue&type=script&lang=js&"
export * from "./PlatFormMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports